import React from 'react';
import ScrollableDataTable from '../../../Base/Components/ScrollableDataTable/ScrollableDataTable';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import useTranslation from '../../../../Hooks/useTranslation';

export interface ILaboratoryResultListItem {
	id: string;
	createdAt: string;
	name: string;
	result: number;
	unit: string;
	lowerReferenceValue: number;
	upperReferenceValue: number;
	chart: string;
	evaluation: {
		value: number;
		type: string;
		color: string;
	};
	acceptedAt: string;
	acceptedBy: string;
	processedAt: string;
	processedBy: string;
}

interface Props {
	items: ILaboratoryResultListItem[];
	onRowClick: (item: ILaboratoryResultListItem) => void;
}

const COLUMNS = [
	{
		key: 'createdAt',
		title: 'component.laboratoryResultItemsList.createdAt',
		renderItem: (item: { createdAt: string }) => (
			<FormattedMomentDate
				date={item.createdAt}
				format={DateFormat.DATE_TIME}
			/>
		),
	},
	{
		key: 'name',
		title: 'component.laboratoryResultItemsList.name',
	},
	{
		key: 'result',
		title: 'component.laboratoryResultItemsList.result',
	},
	{
		key: 'lowerReferenceValue',
		title: 'component.laboratoryResultItemsList.lowerReferenceValue',
	},
	{
		key: 'upperReferenceValue',
		title: 'component.laboratoryResultItemsList.upperReferenceValue',
	},
	{
		key: 'chart',
		title: 'component.laboratoryResultItemsList.chart',
	},
	{
		key: 'evaluation',
		title: 'component.laboratoryResultItemsList.evaluation',
		renderItem: (item: {
			evaluation: { value: number; type: string; color: string };
		}) => (
			<div
				style={{
					textAlign: 'center',
					backgroundColor: item.evaluation.color,
				}}>
				{item.evaluation.value}
			</div>
		),
	},
	{
		key: 'acceptedAt',
		title: 'component.laboratoryResultItemsList.acceptedAt',
		renderItem: (item: { acceptedAt: string }) => (
			<FormattedMomentDate date={item.acceptedAt} format={DateFormat.DATE} />
		),
	},
	{
		key: 'acceptedBy',
		title: 'component.laboratoryResultItemsList.acceptedBy',
	},
	{
		key: 'processedAt',
		title: 'component.laboratoryResultItemsList.processedAt',
		renderItem: (item: { processedAt: string }) => (
			<FormattedMomentDate date={item.processedAt} format={DateFormat.DATE} />
		),
	},
	{
		key: 'processedBy',
		title: 'component.laboratoryResultItemsList.processedBy',
	},
];

const LaboratoryResultItemsList: React.FC<Props> = ({ items, onRowClick }) => {
	return (
		<ScrollableDataTable
			columns={COLUMNS}
			rows={items}
			firstColumnFixed={false}
			onRowClick={onRowClick}
		/>
	);
};

export default LaboratoryResultItemsList;
